import clsx from "clsx";
import React, { useState, useRef, useEffect } from "react";
import PropTypes from "prop-types";

import { Grid } from "@material-ui/core";
import { makeStyles, useTheme } from "@material-ui/core/styles";

import { GeofencesPanelPositions } from "../../constants";

const useStyles = makeStyles((theme) => ({
  floatingPanel: {
    padding: theme.spacing(2),
    borderRadius: 2,
    background: theme.palette.background.paper,
    boxShadow: "0 1px 3px rgba(0,0,0,0.25)",
    overflow: "auto",
    pointerEvents: "all",
  },
  leftPanel: {
    gridColumn: "1 / 2",
    gridRow: "1 / 4",
  },
  topPanel: {
    gridColumn: "2 / 5",
    gridRow: "1",
  },
}));

const FloatingPanel = (props) => {
  const theme = useTheme();
  const classes = useStyles(theme);

  const panelRef = useRef(null);

  const [maxHeight, setMaxHeight] = useState("75vh");

  useEffect(() => {
    if (!panelRef.current || !window.ResizeObserver) return () => {};

    // parentElement is css grid element (it does not have defined height)
    // parentNode of this grid has height that we want to get
    const { parentNode } = panelRef.current.parentElement;

    const observer = new ResizeObserver(() => {
      setMaxHeight(parentNode.offsetHeight - theme.spacing(4));
    });

    observer.observe(parentNode);

    return () => {
      observer.disconnect();
    };
  }, [panelRef]);

  return (
    <Grid
      item
      ref={panelRef}
      style={{ maxHeight }}
      className={clsx(classes.floatingPanel, classes[`${props.position}Panel`])}
    >
      {props.children}
    </Grid>
  );
};

FloatingPanel.propTypes = {
  position: PropTypes.oneOf(Object.values(GeofencesPanelPositions)),
  children: PropTypes.node,
};

FloatingPanel.defaultProps = {
  position: GeofencesPanelPositions.LEFT,
  children: null,
};

export default FloatingPanel;
